import SocialIconLink from './SocialIconLink';

export default SocialIconLink;
